import type { ProductCard } from '@ria-client/supergraph/roundup/types';
import type { ItemList } from 'schema-dts';
import { getProductListSchema } from './schema';

export interface ProductListDataProps {
  offers: ProductCard[];
  title: string;
  id: string;
  url: string;
}

export function ProductListData({ offers, title, id, url }: ProductListDataProps) {
  const __html = JSON.stringify(getProductListSchema({ offers, title, url }))
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026');

  // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml -- JSON.stringify output escapes <, >, and &, so </script> cannot terminate this JSON-LD script.
  return <script id={id} type="application/ld+json" dangerouslySetInnerHTML={{ __html }} />;
}

export type ProductListSchema = ItemList;
